import { render, staticRenderFns } from "./CreateSecurityGroup.vue?vue&type=template&id=85a6b316"
import script from "./CreateSecurityGroup.vue?vue&type=script&lang=js"
export * from "./CreateSecurityGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports